import { render, staticRenderFns } from "./Assemble.vue?vue&type=template&id=32c0c69b&scoped=true&"
import script from "./Assemble.vue?vue&type=script&lang=js&"
export * from "./Assemble.vue?vue&type=script&lang=js&"
import style0 from "./Assemble.vue?vue&type=style&index=0&id=32c0c69b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c0c69b",
  null
  
)

export default component.exports